'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var microLesson = function microLesson() {
  return import('@/page/microLesson');
};
var microLessonList = function microLessonList() {
  return import('@/page/microLesson/microLesson-list');
};
var microLessonWhitelist = function microLessonWhitelist() {
  return import('@/page/microLesson/microLesson-whitelist');
};
var microLessonDetail = function microLessonDetail() {
  return import('@/page/course/course-detail');
};
exports.default = [{
  path: '/microLesson',
  name: 'microLesson',
  component: microLesson,
  children: [{
    path: 'microLesson-list',
    name: 'microLesson-list',
    component: microLessonList
  }, { //免登录
    path: 'microLesson-whitelist',
    name: 'microLesson-whitelist',
    component: microLessonWhitelist
  }, {
    path: 'microLesson-detail',
    name: 'microLesson-detail',
    component: microLessonDetail
  }]
}];